import { cn } from "@/lib/utils";
import { Scribbles } from "@somethings-ui/core/assets";
import { ReactNode } from "react";

interface WizardBackgroundProps {
  children: ReactNode;
  className?: string;
}

export function WizardBackground({ children, className }: WizardBackgroundProps) {
  return (
    <div
      className={cn(
        "relative flex h-full w-full items-center justify-center overflow-x-hidden overflow-y-auto bg-gradient-to-b from-[#f3f9dc] via-[#ffdccc] to-white px-8 py-12",
        className,
      )}
    >
      <img
        aria-hidden
        src={Scribbles.orangeCloud}
        className="pointer-events-none absolute -left-40 -top-24 w-[520px] select-none"
      />
      <img
        aria-hidden
        src={Scribbles.blueCloudTilted}
        className="pointer-events-none absolute -bottom-32 -right-44 w-[640px] select-none"
      />
      {children}
    </div>
  );
}
